import { Icon } from '@ant-design/compatible';
import { Modal as AModal, Col, message, Row, Tooltip } from 'antd';
import { getStatusColor } from 'components/OrderTable/StatusIcon';
import SVGIcon from 'components/SVGIcon/SVGIcon';
import { selectVaInfo } from 'containers/MainLayout/selectors';
import { RootState } from 'containers/OrderDetailsPage/types';
import messages from 'containers/OrdersPage/messages';
import moment from 'moment';
import React, { Fragment, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import translations from 'translations';
import { Order, OrderType } from 'types/schema';
import utilsMessages from 'utils/messages';
import InfoGray from './info-gray.svg';
import { MoneyRow } from './styledComponents';
// import { getPermissionsActive } from 'utils/permissionMap';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { convertTimestamp } from 'utils/dateTimeUtils';
import Money from '../Money/Money';
import VatTooltip from '../VatTooltip';
import ArrowRight from './ArrowRight.svg';
import CopyIcon from './Copy.svg';
import InfoIcon from './Info.svg';
import KamereoBankQr from './kamereoBankQr.png';
import { Icon as InfoIconWrapper, OrderInfoSection } from './Order';

export const Container = styled.div`
  .ant-col {
    width: 100% !important;
  }

  @media (max-width: 767px) {
    padding: 0;
  }
`;
export const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  &:not(:last-child) {
    margin-bottom: 12px;

    @media (max-width: 767px) {
      margin-bottom: 0;
    }
  }

  @media (max-width: 767px) {
    padding: 8px 12px;
    word-break: break-word;
  }
`;
const InfoRowHeader = styled(InfoRow)`
  padding: 16px;
  border-bottom: 1px solid #eaeaeb;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const MoneyLabel = styled.span`
  color: #808289;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;
const TotalLabel = styled(MoneyLabel)<{ isMobileSize?: boolean; size?: number }>`
  color: #343538;
  line-height: 20px;
  font-size: ${({ isMobileSize, size }) => (isMobileSize ? '16px' : size ? `${size}px` : '14px')};
  font-weight: 500;
`;
const OrderId = styled.p`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #343538;
`;
const TransferInstruction = styled.div`
  ${({ marginTop }) => marginTop && `margin-top: ${marginTop}; width: 100% !important`}
  position: relative;
  display: flex;
  gap: 4px;
  align-items: flex-start;
  background: #fffbeb;
  border-radius: 8px;
  padding: 10px 8px;
  margin-bottom: 6px;
`;

const TransferInstructionTextbox = styled.div`
  font-size: 14px;
  color: #242527;
`;
const Modal = styled(AModal)`
  max-width: 536px !important;
  width: 100% !important;
  padding: 0 16px;

  .ant-modal-footer {
    display: none;
  }
`;

const TransferInstructionTitle = styled.div`
  text-align: center;
`;
const QrWrapper = styled.div`
  flex-shrink: 0;
  width: 144px;
  background: #f6f6f6;
  border-radius: 8px;
  padding: 10px;
`;
const QrTitle = styled.div`
  font-size: 14px;
  color: #808289;
  text-align: center;
`;
const QrImage = styled.img`
  width: 124px;
  height: 124px;
  margin-top: 4px;
`;
const AccountInfoWrapper = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 16px;
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: center;
  }
`;
const AccountInfoTextBox = styled.div`
  width: 100%;
`;
const AccountInfoRow = styled.div`
  display: flex;
  justify-content: space-between;

  &:not(:last-child) {
    margin-bottom: 7px;
  }
`;
const AccountInfoTextWrapper = styled.div``;
const AccountInfoLabel = styled.div`
  color: #808289;
  font-size: 14px;
`;
const AccountInfoContent = styled.div`
  color: #242527;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  margin-top: 4px;
`;
const SeparateLine = styled.div`
  margin: 24px 0;
  height: 1px;
  width: 100%;
  background: #d9d9d9;
`;
const ImportantNoteTitle = styled.div`
  color: #242527;
  font-size: 14px;
  font-weight: 600;
`;
const ImportantNoteText = styled.div`
  color: #242527;
  font-size: 14px;
  font-weight: 400;
`;

const Copy = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;
const CopyText = styled.div`
  color: #43a047;
  font-size: 14px;
`;
const OrderRow = styled(Row)`
  margin-left: 0 !important;
  margin-right: 0 !important;
`;
const OrderCol = styled(Col)`
  padding-left: 0 !important;
  padding-right: 0 !important;
`;
const OrderRowStatus = styled.p<{ status: string }>`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ status }) => getStatusColor(status)};
`;
const Label = styled.span<{ isMobileSize?: boolean }>`
  font-size: ${({ isMobileSize }) => (isMobileSize ? '12px' : '14px')};
  font-weight: 500;
  line-height: ${({ isMobileSize }) => (isMobileSize ? '16px' : '20px')};
  color: #808289;
  min-width: 180px;

  @media (max-width: 767px) {
    min-width: 180px;
  }
`;
const Value = styled(Label)`
  color: #343538;
  flex: 1;
  word-break: break-word;

  @media (max-width: 767px) {
    font-size: 13px;
  }
`;
const FFMId = styled(Label)`
  color: #388bff;
`;
const OrderColRightWrapper = styled.div`
  background-color: #fff;
  @media (max-width: 767px) {
    padding: 12px;
  }
`;
const OrderColRightInner = styled.div`
  padding: 16px;
`;
const OrderColLeftWrapper = styled.div`
  padding: 16px;
  @media (max-width: 767px) {
    padding: 0 !important;
  }
`;

const MoneyInfoWrapper = styled.div<{ showInfoTooltip: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-bottom: ${({ showInfoTooltip }) => (showInfoTooltip ? '12px' : '0')};

  @media (max-width: 767px) {
    flex-wrap: wrap;
  }
`;
const MoneyInfo = styled.div`
  color: #808289;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`;
const MoneyWarningWrapper = styled(Link)`
  padding: 12px;
  border-radius: 6px;
  background-color: #fffbe6;
  margin-top: 12px;
  display: flex;
  align-items: center;

  @media (max-width: 767px) {
    padding: 10px;
    flex-wrap: wrap;
  }
`;
const MoneyWarningText = styled.p`
  color: #343538;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 0;
  flex: 1;

  @media (max-width: 767px) {
    font-size: 13px;
  }
`;
export const NoteIcon = styled(SVGIcon)<any>`
  & > div {
    display: block;
  }
  ${({ note }) =>
    note === 'true'
      ? `
    path {
      fill: #2e904e;
    }
  `
      : ``};
`;
const TotalInclVatWrapper = styled.div`
  border-top: 1px solid #e8e8e8;
  padding: 12px 16px;
`;
interface IStateProps {
  vaInfo: any;
}

interface OrderSummaryProps extends IStateProps {
  isMobileSize: boolean;
  order: Order;
  onCancelOrder: () => void;
  reOrderAll: () => void;
  onApproveOrder: () => void;
  onDisapproveOrder: () => void;
  onUpdateDelivery: (data: any) => void;
  onPrintOrderInvoice: (data: string) => void;
  permissions: string[];
  showInfoTooltip: boolean;
}

const CopyElement = (text: string) => {
  const copy = (text: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        message.success(translations(messages.copySuccess));
      })
      .catch(() => {
        message.error(translations(messages.copyFail));
      });
  };
  return (
    <Copy onClick={() => copy(text)}>
      <SVGIcon src={CopyIcon} />
      <CopyText>
        <FormattedMessage {...messages.copy} />
      </CopyText>
    </Copy>
  );
};

class OrderSummary extends React.Component<OrderSummaryProps> {
  public state = { expandOrder: false, isShowTransferPopup: false };

  public onExpandOrder = () => {
    if (this.props.isMobileSize) {
      this.setState({ expandOrder: !this.state.expandOrder });
    }
  };

  public orderType = (orderType) => {
    switch (orderType) {
      case OrderType.Gift:
        return translations(messages.giftOrder);
      case OrderType.Sample:
        return translations(messages.sampleOrder);
      case OrderType.Redelivery:
        return translations(messages.redeliveryOrder);
      case OrderType.Employee:
        return translations(messages.employeeOrder);
      default:
        return '';
    }
  };

  public orderForDependOnOrderType = (order: any) => {
    switch (order?.orderType) {
      case OrderType.Employee:
      case OrderType.Gift:
      case OrderType.Sample:
        return order?.zeroOrderInfo.receiver;
      case OrderType.Redelivery:
        return order?.zeroOrderInfo.orderId;
      case OrderType.PaidOrder:
        return '';
      default:
        return 'Chưa xác định được';
    }
  };

  renderMoneySectionDesktop = (order: Order) => {
    return (
      <OrderColRightWrapper>
        <OrderColRightInner>
          <MoneyRow showInfoTooltip={this.props.showInfoTooltip}>
            <MoneyLabel>
              <FormattedMessage {...messages.subTotal} />
            </MoneyLabel>
            <TotalLabel isMobileSize={false}>
              <Money type="new">{order?.subTotalBeforeVat || 0}</Money>
            </TotalLabel>
          </MoneyRow>

          {this.props.showInfoTooltip && (
            <MoneyInfoWrapper showInfoTooltip={this.props.showInfoTooltip}>
              <MoneyInfo>
                <FormattedMessage {...messages.priceByActualWeight} />
              </MoneyInfo>
              <Tooltip
                title={
                  <span>
                    <b>
                      <FormattedMessage {...messages.note} />
                    </b>{' '}
                    <FormattedMessage {...messages.noteText} />
                  </span>
                }
                placement="topRight"
                overlayStyle={{ maxWidth: '300px' }}
              >
                <SVGIcon src={InfoGray} />
              </Tooltip>
            </MoneyInfoWrapper>
          )}

          {!order.fulfillmentNote || !order.discount ? (
            <>
              <MoneyRow>
                <MoneyLabel>
                  <FormattedMessage {...utilsMessages.serviceFee} />
                </MoneyLabel>
                <TotalLabel isMobileSize={false}>
                  <Money>{order?.deliveryFee?.fee || 0}</Money>
                </TotalLabel>
              </MoneyRow>

              <MoneyRow>
                <MoneyLabel>
                  <FormattedMessage {...utilsMessages.freeShippingText} />
                </MoneyLabel>
                <TotalLabel isMobileSize={false}>
                  {Number(order.deliveryFee?.discount) > 0 ? '-' : ''}
                  <Money>{order?.deliveryFee?.discount || 0}</Money>
                </TotalLabel>
              </MoneyRow>

              <MoneyRow>
                <MoneyLabel>
                  <FormattedMessage {...utilsMessages.promotion} />
                </MoneyLabel>
                <TotalLabel isMobileSize={false}>
                  {Number(order.discount) > 0 ? '-' : ''}
                  <Money>{order.discount ? order.discount : 0}</Money>
                </TotalLabel>
              </MoneyRow>

              <MoneyRow>
                <div style={{ display: 'flex', gap: '4px', color: 'rgba(0, 0, 0, 0.54)' }}>
                  <MoneyLabel>VAT</MoneyLabel>
                  <VatTooltip
                    productVat={order.totalVatOnProducts || 0}
                    serviceFeeVat={!order?.deliveryFee?.discount ? (order?.deliveryFee?.additionalVat as number) : 0}
                  />
                </div>
                <TotalLabel isMobileSize={false}>
                  <Money>{order?.totalVat || 0}</Money>
                </TotalLabel>
              </MoneyRow>
            </>
          ) : null}

          {order.fulfillmentNote && order.discount ? (
            <>
              <MoneyWarningWrapper to={`/phieu-giao/${order.fulfillmentNote.fulfillmentNoteId}`}>
                <MoneyWarningText>
                  <FormattedMessage {...messages.checkFFMNote} />
                </MoneyWarningText>

                <SVGIcon src={ArrowRight} style={{ minWidth: '16px' }} />
              </MoneyWarningWrapper>
            </>
          ) : null}
        </OrderColRightInner>

        <TotalInclVatWrapper>
          <MoneyRow>
            <MoneyLabel>
              <FormattedMessage {...messages.total} />
            </MoneyLabel>
            <TotalLabel size={18} isMobileSize={false}>
              <Money>{order.total || 0}</Money>
            </TotalLabel>
          </MoneyRow>
        </TotalInclVatWrapper>
      </OrderColRightWrapper>
    );
  };

  public render() {
    const {
      order,
      vaInfo,
      // isFreeshipOffer,
      isMobileSize,
    } = this.props;
    // const isExpandOrder = this.props.isMobileSize ? this.state.expandOrder : true;
    // const canApproveOrder = getPermissionsActive(['ORDER_APPROVE'], permissions);
    const bankAccount = {
      accountName: vaInfo?.vaName || 'CÔNG TY TNHH KAMEREO',
      accountNumber: vaInfo.vaAccountNumber || '137483',
      bank: 'NGÂN HÀNG PHƯƠNG ĐÔNG (OCB) - CN TP.HCM',
      qrCode: vaInfo?.qrDataBase64 || KamereoBankQr,
    };
    const transferNotes = [
      <FormattedMessage key="1" {...messages.firstImportantNote} />,
      <FormattedMessage key="3" {...messages.thirdImportantNote} />,
    ];

    return (
      <Container>
        <OrderRow gutter={8}>
          <OrderCol span={24}>
            {!isMobileSize ? (
              <InfoRowHeader>
                <OrderId>
                  <FormattedMessage {...messages.order} />: {order.id}
                </OrderId>
                <OrderRowStatus status={order?.status}>{order?.statusText}</OrderRowStatus>
              </InfoRowHeader>
            ) : null}
          </OrderCol>
        </OrderRow>
        <OrderRow gutter={8}>
          <Fragment>
            <OrderCol lg={16} sm={24} style={{ borderRight: isMobileSize ? 'none' : '1px solid #EAEAEB' }}>
              {isMobileSize ? (
                <InfoRow>
                  <Label isMobileSize={isMobileSize}>
                    <FormattedMessage {...utilsMessages.orderId} />
                  </Label>
                  <Value>{order.id}</Value>
                </InfoRow>
              ) : null}
              <OrderColLeftWrapper>
                {order.fulfillmentNote && order.fulfillmentNote?.fulfillmentNoteId ? (
                  <InfoRow>
                    <Label isMobileSize={isMobileSize}>
                      <FormattedMessage {...utilsMessages.ffmNoteId} />
                    </Label>
                    <Link to={`/phieu-giao/${order.fulfillmentNote.fulfillmentNoteId}`}>
                      <FFMId>{order.fulfillmentNote.fulfillmentNoteShortCode}</FFMId>
                    </Link>
                  </InfoRow>
                ) : null}

                {isMobileSize && order.fulfillmentNote && order.fulfillmentNote?.orderIds?.length > 1 ? (
                  <OrderInfoSection isMobileSize>
                    <InfoIconWrapper src={InfoIcon} />
                    <span>
                      <FormattedMessage
                        {...messages.orderFFMNoteInfo}
                        values={{
                          fulfillmentNote: order.fulfillmentNote?.fulfillmentNoteShortCode,
                          orderIds: order.fulfillmentNote?.orderIds
                            ?.map((id: string) => `${id.substring(0, 5)}...`)
                            .join(', '),
                        }}
                      />{' '}
                      <Link to={`/phieu-giao/${order.fulfillmentNote.fulfillmentNoteId}`}>
                        <FormattedMessage {...messages.seeHere} />
                      </Link>
                    </span>
                  </OrderInfoSection>
                ) : null}

                <InfoRow>
                  <Label isMobileSize={isMobileSize}>
                    <FormattedMessage {...utilsMessages.deliveryDate} />
                  </Label>
                  <Value>
                    {order?.deliveryTime?.start && order?.deliveryTime?.end
                      ? `${moment(order?.deliveryTime?.start).format('HH:mm')} - ${moment(order?.deliveryTime?.end).format('HH:mm')} | ${moment(order?.deliveryTime?.start).format('DD/MM/YYYY')}`
                      : '-'}
                  </Value>
                </InfoRow>

                {isMobileSize ? (
                  <InfoRow>
                    <Label isMobileSize={isMobileSize}>
                      <FormattedMessage {...utilsMessages.status} />
                    </Label>
                    <Value>
                      <OrderRowStatus status={order?.status}>{order?.statusText}</OrderRowStatus>
                    </Value>
                  </InfoRow>
                ) : null}
                <InfoRow>
                  <Label isMobileSize={isMobileSize}>
                    <FormattedMessage {...utilsMessages.paymentMethod} />
                  </Label>
                  <Value>
                    <FormattedMessage {...utilsMessages[order?.paymentMethod || 'COD']} />
                  </Value>
                </InfoRow>
                {order?.orderType !== OrderType.PaidOrder && (
                  <InfoRow>
                    <Label isMobileSize={isMobileSize}>
                      <FormattedMessage {...messages.orderType} />
                    </Label>
                    <Col>
                      <Row>
                        <p style={{ marginRight: 10 }}>{this.orderType(order?.orderType)}</p>
                        {order?.zeroOrderInfo?.reason && (
                          <Tooltip title={order?.zeroOrderInfo?.reason} placement="topLeft" style={{ marginLeft: 20 }}>
                            <Icon type="exclamation-circle" />
                          </Tooltip>
                        )}
                      </Row>
                      <p>{this.orderForDependOnOrderType(order)}</p>
                    </Col>
                  </InfoRow>
                )}
                <InfoRow>
                  <Label isMobileSize={isMobileSize}>
                    <FormattedMessage {...messages.creator} />
                  </Label>
                  <Value>{order?.creator?.name}</Value>
                </InfoRow>
                <InfoRow>
                  <Label isMobileSize={isMobileSize}>
                    <FormattedMessage {...messages.orderDate} />
                  </Label>
                  <Value>{moment(order?.orderDate).format('HH:mm | DD/MM/YYYY')}</Value>
                </InfoRow>

                {order?.cancelledAudit?.userName && (
                  <InfoRow>
                    <Label isMobileSize={isMobileSize}>
                      <FormattedMessage {...messages.cancelPerson} />
                    </Label>
                    <Value>{order?.cancelledAudit?.userName}</Value>
                  </InfoRow>
                )}

                {order?.cancelledAudit?.time && (
                  <InfoRow>
                    <Label isMobileSize={isMobileSize}>
                      <FormattedMessage {...messages.cancelTime} />
                    </Label>
                    <Value>{convertTimestamp(Number(order?.cancelledAudit?.time))}</Value>
                  </InfoRow>
                )}

                {order.note && (
                  <InfoRow>
                    <Label isMobileSize={isMobileSize}>
                      <FormattedMessage {...utilsMessages.note} />
                    </Label>
                    <Value>{order.note}</Value>
                  </InfoRow>
                )}
              </OrderColLeftWrapper>
            </OrderCol>

            {!isMobileSize && (
              <OrderCol lg={8} sm={24}>
                {this.renderMoneySectionDesktop(order)}
              </OrderCol>
            )}
          </Fragment>
        </OrderRow>

        <Modal
          open={this.state.isShowTransferPopup}
          closeIcon={true}
          centered={true}
          destroyOnClose={true}
          maskClosable={true}
          onCancel={() => {
            this.setState({
              ...this.state,
              isShowTransferPopup: !this.state.isShowTransferPopup,
            });
          }}
        >
          <TransferInstructionTitle>{translations(messages.transferInstructions)}</TransferInstructionTitle>
          <AccountInfoWrapper>
            {vaInfo.vaAccountNumber ? (
              !!vaInfo?.qrDataBase64 && (
                <QrWrapper>
                  <QrTitle>
                    <FormattedMessage {...messages.qrCode} />
                  </QrTitle>
                  <QrImage src={bankAccount.qrCode} />
                </QrWrapper>
              )
            ) : (
              <QrWrapper>
                <QrTitle>
                  <FormattedMessage {...messages.qrCode} />
                </QrTitle>
                <QrImage src={bankAccount.qrCode} />
              </QrWrapper>
            )}
            <AccountInfoTextBox>
              <AccountInfoRow>
                <AccountInfoTextWrapper>
                  <AccountInfoLabel>
                    <FormattedMessage {...messages.accountName} />
                  </AccountInfoLabel>
                  <AccountInfoContent>{bankAccount.accountName}</AccountInfoContent>
                </AccountInfoTextWrapper>
              </AccountInfoRow>
              <AccountInfoRow>
                <AccountInfoTextWrapper>
                  <AccountInfoLabel>
                    <FormattedMessage {...messages.accountNumber} />
                  </AccountInfoLabel>
                  <AccountInfoContent>{bankAccount.accountNumber}</AccountInfoContent>
                </AccountInfoTextWrapper>
                {CopyElement(bankAccount.accountNumber)}
              </AccountInfoRow>
              <AccountInfoRow>
                <AccountInfoTextWrapper>
                  <AccountInfoLabel>
                    <FormattedMessage {...messages.bank} />
                  </AccountInfoLabel>
                  <AccountInfoContent>{bankAccount.bank}</AccountInfoContent>
                </AccountInfoTextWrapper>
              </AccountInfoRow>
            </AccountInfoTextBox>
          </AccountInfoWrapper>
          <SeparateLine />
          <AccountInfoRow>
            <AccountInfoTextWrapper>
              <AccountInfoLabel>
                <FormattedMessage {...messages.totalAmount} />
              </AccountInfoLabel>
              <AccountInfoContent>
                <Money>{order?.total}</Money>
              </AccountInfoContent>
            </AccountInfoTextWrapper>
            {CopyElement(order?.total?.toString())}
          </AccountInfoRow>
          <AccountInfoRow>
            <AccountInfoTextWrapper>
              <AccountInfoLabel>
                <FormattedMessage {...messages.tranferMessage} />
              </AccountInfoLabel>
              <AccountInfoContent>{order?.id}</AccountInfoContent>
            </AccountInfoTextWrapper>
            {CopyElement(order?.id)}
          </AccountInfoRow>
          <TransferInstruction marginTop="14px">
            <SVGIcon src={InfoIcon} style={{ marginTop: '3px' }} />
            <TransferInstructionTextbox>
              <ImportantNoteTitle>
                <FormattedMessage {...messages.importantNotes} />
              </ImportantNoteTitle>
              {transferNotes.map((note, idx) => (
                <ImportantNoteText key={idx}>
                  {`${idx + 1}. `}
                  {note}
                </ImportantNoteText>
              ))}
            </TransferInstructionTextbox>
          </TransferInstruction>
        </Modal>
      </Container>
    );
  }
}

const mapStateToProps = createStructuredSelector<RootState, IStateProps>({
  vaInfo: selectVaInfo(),
});

export const MoneySection = ({
  isMobileSize,
  order,
  hideInfoText,
}: {
  isMobileSize: boolean;
  order: any;
  hideInfoText?: boolean;
}) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <OrderColRightWrapper>
      <div
        onClick={order?.fulfillmentNote && order?.discount ? () => {} : toggleExpand}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          cursor: 'pointer',
          marginBottom: expanded ? '16px' : '0',
        }}
      >
        <MoneyLabel>
          {expanded ? <FormattedMessage {...messages.subTotal} /> : <FormattedMessage {...messages.total} />}
          {!order?.fulfillmentNote || !order?.discount ? (
            expanded ? (
              <UpOutlined style={{ fontSize: '10px', marginLeft: '4px', color: '#808289' }} />
            ) : (
              <DownOutlined style={{ fontSize: '10px', marginLeft: '4px', color: '#808289' }} />
            )
          ) : null}
        </MoneyLabel>
        <TotalLabel>
          <Money>{expanded ? order?.subTotalBeforeVat : order?.total}</Money>
        </TotalLabel>
      </div>

      {order.fulfillmentNote && order.discount ? (
        <MoneyWarningWrapper to={`/phieu-giao/${order.fulfillmentNote.fulfillmentNoteId}`}>
          <MoneyWarningText>
            <FormattedMessage {...messages.checkFFMNote} />
          </MoneyWarningText>
          <SVGIcon src={ArrowRight} style={{ minWidth: '16px' }} />
        </MoneyWarningWrapper>
      ) : null}

      {isMobileSize && (
        <>
          {expanded && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <MoneyRow>
                <MoneyLabel>
                  <FormattedMessage {...utilsMessages.serviceFee} />
                </MoneyLabel>
                <TotalLabel>
                  <Money>{order?.deliveryFee?.fee || 0}</Money>
                </TotalLabel>
              </MoneyRow>

              <MoneyRow>
                <MoneyLabel>
                  <FormattedMessage {...utilsMessages.freeShippingText} />
                </MoneyLabel>
                <TotalLabel>
                  {order?.deliveryFee?.discount > 0 ? '-' : ''}
                  <Money>{order?.deliveryFee?.discount || 0}</Money>
                </TotalLabel>
              </MoneyRow>

              <MoneyRow>
                <MoneyLabel>
                  <FormattedMessage {...utilsMessages.promotion} />
                </MoneyLabel>
                <TotalLabel>
                  {order?.discount > 0 ? '-' : ''}
                  <Money>{order?.discount || 0}</Money>
                </TotalLabel>
              </MoneyRow>

              <MoneyRow>
                <div style={{ display: 'flex', gap: '4px', color: 'rgba(0, 0, 0, 0.54)' }}>
                  <MoneyLabel>VAT</MoneyLabel>
                  <VatTooltip
                    productVat={order.totalVatOnProducts || 0}
                    serviceFeeVat={!order?.deliveryFee?.discount ? (order?.deliveryFee?.additionalVat as number) : 0}
                  />
                </div>
                <TotalLabel>
                  <Money>{order?.totalVat || 0}</Money>
                </TotalLabel>
              </MoneyRow>

              <div
                style={{
                  borderTop: '1px solid rgba(0, 0, 0, 0.06)',
                  paddingTop: '16px',
                  marginTop: '8px',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <MoneyLabel>
                  <FormattedMessage {...utilsMessages.total} />
                </MoneyLabel>
                <TotalLabel>
                  <Money>{order?.total}</Money>
                </TotalLabel>
              </div>
            </div>
          )}
          {!hideInfoText && (
            <MoneyInfoWrapper>
              <MoneyInfo>
                <FormattedMessage {...messages.priceByActualWeight} />
              </MoneyInfo>
              <Tooltip
                title={
                  <span>
                    <b>
                      <FormattedMessage {...messages.note} />
                    </b>{' '}
                    <FormattedMessage {...messages.noteText} />
                  </span>
                }
                placement="topRight"
                overlayStyle={{ maxWidth: '300px' }}
              >
                <SVGIcon src={InfoGray} />
              </Tooltip>
            </MoneyInfoWrapper>
          )}
        </>
      )}

      {!isMobileSize && (
        <>
          {!hideInfoText && (
            <MoneyInfoWrapper>
              <MoneyInfo>
                <FormattedMessage {...messages.priceByActualWeight} />
              </MoneyInfo>
              <Tooltip
                title={
                  <span>
                    <b>
                      <FormattedMessage {...messages.note} />
                    </b>{' '}
                    <FormattedMessage {...messages.noteText} />
                  </span>
                }
                placement="topRight"
                overlayStyle={{ maxWidth: '300px' }}
              >
                <SVGIcon src={InfoGray} />
              </Tooltip>
            </MoneyInfoWrapper>
          )}

          {order.fulfillmentNote ? (
            <MoneyWarningWrapper to={`/phieu-giao/${order.fulfillmentNote.fulfillmentNoteId}`}>
              <MoneyWarningText>
                <FormattedMessage {...messages.checkFFMNote} />
              </MoneyWarningText>
              <SVGIcon src={ArrowRight} style={{ minWidth: '16px' }} />
            </MoneyWarningWrapper>
          ) : null}
        </>
      )}
    </OrderColRightWrapper>
  );
};

export default connect(mapStateToProps)(OrderSummary);
